import classNames from 'classnames';
import './SofaTitlePanel.css';

type Props = React.PropsWithChildren<{
  className?: string;
  title: string;
}>;

export const SofaTitlePanel = ({ title, className, children }: Props) => {
  return (
    <div className={classNames('sofas-title-panel', className)}>
      <h3 className="sofas-title-panel__title">{title}</h3>
      <div className="sofas-title-panel__body">{children}</div>
    </div>
  );
};
